var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle, _polygon, _polygon2, _rect, _rect2, _rect3, _path54, _path55, _rect4, _rect5, _rect6, _path56, _path57, _rect7, _rect8, _rect9, _path58, _path59, _rect10, _rect11, _rect12, _path60, _path61, _rect13, _rect14, _rect15, _path62, _path63, _rect16, _rect17, _rect18, _path64, _path65, _rect19, _rect20, _rect21, _path66, _path67, _rect22, _rect23, _rect24, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawTouristMapRe293E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 721.11203,
    height: 582.53467,
    viewBox: "0 0 721.11203 582.53467",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.76213,554.44846h-2.29359a1.148,1.148,0,0,1-1.14679-1.14679v-2.29359a1.148,1.148,0,0,1,1.14679-1.1468h2.29359a1.148,1.148,0,0,1,1.14679,1.1468v2.29359A1.148,1.148,0,0,1,364.76213,554.44846Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.65845,551.92118a.7393.7393,0,0,1-.13047-.0112.76433.76433,0,0,1-.624-.88286l7.56093-43.99591a.76457.76457,0,0,1,1.507.25907L364.411,551.28619A.76486.76486,0,0,1,363.65845,551.92118Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.65659,551.92118a.76485.76485,0,0,1-.75259-.635l-7.56074-43.99591a.76457.76457,0,0,1,1.507-.25907l7.56075,43.99591a.76435.76435,0,0,1-.624.88286A.74075.74075,0,0,1,363.65659,551.92118Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M379.93459,499.50024c.737-5.22111-2.05135-9.93165-6.22842-10.5213s-8.16043,3.16495-8.89747,8.386c-.62161,4.40343,1.26947,8.43329,4.38142,9.94455l-.17719,1.25522,3.78147.53381.1772-1.25522C376.38028,507.25257,379.313,503.90366,379.93459,499.50024Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ff6584"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.37578,497.12436c-.90481-5.19466-5.007-8.819-9.163-8.09514s-6.79113,5.52178-5.88632,10.71644c.7631,4.38112,3.80214,7.63384,7.22808,8.11452l.21753,1.24886,3.76232-.65532-.21753-1.24886C361.37858,505.59415,363.13888,501.50548,362.37578,497.12436Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.61534,551.00808a.76457.76457,0,0,1-.76453-.76453V505.01573a.76453.76453,0,1,1,1.529,0v45.22782A.76456.76456,0,0,1,363.61534,551.00808Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370.77954,496.32824c0-5.27287-3.41944-9.54741-7.63792-9.54741s-7.63793,4.27454-7.63793,9.54741c0,4.44708,2.4358,8.173,5.72845,9.23448v1.26766h3.819v-1.26766C368.34374,504.50128,370.77954,500.77532,370.77954,496.32824Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M719.63468,741.26733l-.153-.01453L480.36622,719.04035,262.9303,739.239A21.4979,21.4979,0,0,1,239.444,717.8336V200.70651a21.40161,21.40161,0,0,1,19.50937-21.40539l221.41287-20.56845.153.01453,239.11544,22.21245L937.0696,160.761A21.49791,21.49791,0,0,1,960.556,182.1664V699.29309a21.40191,21.40191,0,0,1-19.50927,21.40579ZM480.36622,715.71846l.153.01453,239.11544,22.21245,221.106-20.53939a18.10973,18.10973,0,0,0,16.50794-18.113V182.1664a18.19059,18.19059,0,0,0-19.873-18.11257L719.63468,184.28154l-.153-.01453L480.36622,162.05456,259.25928,182.594l-.153-1.64642.153,1.64642a18.10963,18.10963,0,0,0-16.50794,18.11256V717.8336a18.19073,18.19073,0,0,0,19.873,18.11257Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M928.41362,291.083c0-14.70523-11.929-49.6-26.6442-49.6s-26.64419,34.89479-26.64419,49.6a26.6442,26.6442,0,0,0,53.28839,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M901.76942,350.084a.3047.3047,0,0,1-.30468-.30469V287.58061a.30469.30469,0,0,1,.60937,0v62.19865A.30471.30471,0,0,1,901.76942,350.084Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M901.76957,299.2015a.304.304,0,0,1-.23037-.105l-15.32368-17.67175a.30474.30474,0,0,1,.46045-.39931l15.32368,17.67175a.30477.30477,0,0,1-.23008.50434Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M901.76942,309.40013a.30469.30469,0,0,1-.21542-.52011l8.70719-8.70734a.30465.30465,0,0,1,.43084.43085l-8.70719,8.70733A.30356.30356,0,0,1,901.76942,309.40013Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M872.91116,349.68021a11.12328,11.12328,0,0,1,22.24656,0",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M884.03444,349.68021a.30065.30065,0,0,1-.30063-.30063v-5.86227a.30063.30063,0,0,1,.60126,0v5.86227A.30065.30065,0,0,1,884.03444,349.68021Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M884.03429,347.66579a.29925.29925,0,0,1-.19567-.07252l-3.60751-3.09627a.30062.30062,0,1,1,.3916-.45623l3.60755,3.09627a.30064.30064,0,0,1-.196.52875Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M907.18288,349.68021a11.12328,11.12328,0,0,1,22.24656,0",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M918.30616,349.68021a.30065.30065,0,0,1-.30063-.30063v-5.86227a.30063.30063,0,1,1,.60126,0v5.86227A.30065.30065,0,0,1,918.30616,349.68021Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M918.306,347.66579a.29925.29925,0,0,1-.19567-.07252l-3.60755-3.09627a.30064.30064,0,0,1,.39164-.45623L918.502,347.137a.30063.30063,0,0,1-.196.52875Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M577.95654,248.96538c7.30767-10.46035,16.16289-41.21029,5.69547-48.52291s-36.29371,11.58123-43.60138,22.04158a23.1199,23.1199,0,0,0,37.90591,26.48133Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M529.68343,277.69417a.2644.2644,0,0,1-.06532-.36815l30.90923-44.24409a.26438.26438,0,0,1,.43347.30282l-30.90923,44.2441A.26441.26441,0,0,1,529.68343,277.69417Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M554.96925,241.49976a.26375.26375,0,0,1-.11167-.18919L552.73917,221.125a.26443.26443,0,0,1,.526-.05522l2.11841,20.18554a.26445.26445,0,0,1-.41429.24442Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M549.901,248.75433a.26438.26438,0,0,1,.10523-.477l10.52078-1.86686a.26436.26436,0,1,1,.09237.52058l-10.52078,1.86686A.26346.26346,0,0,1,549.901,248.75433Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M509.35617,263.066a9.652,9.652,0,0,1,15.82476,11.05529",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M517.26855,268.59369a.26088.26088,0,0,1-.06445-.36325l2.91321-4.17a.26087.26087,0,0,1,.4277.29879l-2.91322,4.17A.26087.26087,0,0,1,517.26855,268.59369Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M518.2695,267.16068a.2596.2596,0,0,1-.10315-.14882l-1.02748-3.99522a.26086.26086,0,1,1,.50528-.12992l1.0275,3.99523a.26086.26086,0,0,1-.40215.27873Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M533.73485,280.09716a9.652,9.652,0,1,1,15.82476,11.05529",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M541.64723,285.6248a.26088.26088,0,0,1-.06445-.36324l2.91322-4.17a.26086.26086,0,0,1,.42769.29879l-2.91321,4.17A.26088.26088,0,0,1,541.64723,285.6248Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M542.64818,284.1918a.2597.2597,0,0,1-.10315-.14882l-1.0275-3.99524a.26087.26087,0,0,1,.5053-.12991l1.02751,3.99524a.26087.26087,0,0,1-.40216.27873Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M727.888,477.1377q8.81806,8.09886,17.52069,16.31354c-1.48856.08267-3.03444.14883-4.62191.19844-2.24111.07443-4.57265.10749-7.02007.10749-26.84767,0-40.474-4.40707-53.63721-8.67354-12.50192-4.04326-24.309-7.86326-48.55182-7.86326-24.25128,0-36.05879,3.82-48.55223,7.86326-13.1717,4.26647-26.798,8.67354-53.64528,8.67354-26.85575,0-40.474-4.40707-53.64529-8.67354-12.21244-3.95232-23.76358-7.68961-46.89855-7.855-.54584-.00827-1.09128-.00827-1.65368-.00827v-16.5368c.55392,0,1.10784,0,1.65368.00827,25.76447.17361,39.09323,4.48974,51.99161,8.657,12.50192,4.05154,24.30942,7.87154,48.55223,7.87154s36.0503-3.82,48.55182-7.87154c13.17171-4.25819,26.78994-8.66526,53.64569-8.66526,26.84727,0,40.4655,4.40707,53.63681,8.66526,10.4433,3.3818,20.40656,6.60645,37.53886,7.57389C724.3985,477.02193,726.10184,477.0881,727.888,477.1377Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M938.16977,477.22037v16.5368c-26.85575,0-40.474-4.40707-53.64529-8.67354-12.50192-4.04326-24.309-7.86326-48.55223-7.86326-24.25128,0-36.05838,3.82-48.5603,7.86326-.67786.22321-1.3642.43819-2.05055.66146-1.174.38036-2.36465.76068-3.5718,1.13276q-6.84626-6.70977-13.74218-13.30382c1.28144-.31421,2.5217-.645,3.74581-.98395,3.64609-1.00877,7.06085-2.1167,10.53374-3.24125,13.1717-4.25819,26.78953-8.66526,53.64528-8.66526s40.474,4.40707,53.64569,8.66526C902.11946,473.40037,913.927,477.22037,938.16977,477.22037Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M572.76419,350.0441C526.4777,316.33381,477.7769,284.3682,428.026,255.04016l-2.49708-1.47175v99.46885H576.87376Zm-143.92791-.3142V259.36456c47.32852,27.9968,93.67275,58.37489,137.86751,90.36534Zm378.18,204.73385q-30.02666-31.21732-61.60766-61.01251Q736.702,485.22832,727.888,477.1377q-53.79024-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26675H809.712Zm-378.18-.50436V386.11086H615.1894q55.27878,42.9998,107.5639,90.81186,9.07848,8.29734,18.03343,16.727,31.30385,29.419,61.14458,60.30971Zm378.18.50436q-30.02666-31.21732-61.60766-61.01251Q736.702,485.22832,727.888,477.1377q-53.79024-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26675H809.712Zm-378.18-.50436V386.11086H615.1894q55.27878,42.9998,107.5639,90.81186,9.07848,8.29734,18.03343,16.727,31.30385,29.419,61.14458,60.30971ZM572.76419,350.0441C526.4777,316.33381,477.7769,284.3682,428.026,255.04016l-2.49708-1.47175v99.46885H576.87376Zm-143.92791-.3142V259.36456c47.32852,27.9968,93.67275,58.37489,137.86751,90.36534Zm143.92791.3142C526.4777,316.33381,477.7769,284.3682,428.026,255.04016l-2.49708-1.47175v99.46885H576.87376Zm-143.92791-.3142V259.36456c47.32852,27.9968,93.67275,58.37489,137.86751,90.36534Zm378.18,204.73385q-30.02666-31.21732-61.60766-61.01251Q736.702,485.22832,727.888,477.1377q-53.79024-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26675H809.712Zm-378.18-.50436V386.11086H615.1894q55.27878,42.9998,107.5639,90.81186,9.07848,8.29734,18.03343,16.727,31.30385,29.419,61.14458,60.30971ZM261.83114,587.033v3.30736H392.45532v47.95672H261.83114v3.30736H395.76268V587.033Zm163.69778,84.33768v33.51186l3.30736-.306V674.678H938.16977v-3.30736Zm512.64085-81.03032V587.033H425.52892v54.57144H938.16977v-3.30736H428.83628V590.34036ZM629.30382,349.7299A1613.79514,1613.79514,0,0,0,428.83628,217.64219v-33.487l-3.30736.30593v33.74621l2.54673,2.80013A1610.47844,1610.47844,0,0,1,627.7325,352.69l.44653.34726H938.16977V349.7299Zm-236.8485,0H261.83114v3.30736H395.76268V187.22277l-3.30736.30592Zm545.71445,33.0736H665.65168l3.56373,2.927q50.32924,41.41232,98.832,87.84354,6.89592,6.59811,13.74218,13.30382,34.08233,33.301,66.83355,68.77656l2.72663,1.61234h86.82v-3.30736h-86.6115q-32.39574-35.12416-66.19687-68.2143-6.759-6.623-13.56817-13.155-47.45266-45.53-96.93085-86.47922H938.16977ZM261.83114,671.37068V674.678H392.45532v33.272l3.30736-.30593V671.37068Zm0-288.56718v3.30736H392.45532V553.95939H261.83114v3.30736H395.76268V382.8035Zm310.93305-32.7594C526.4777,316.33381,477.7769,284.3682,428.026,255.04016l-2.49708-1.47175v99.46885H576.87376Zm-143.92791-.3142V259.36456c47.32852,27.9968,93.67275,58.37489,137.86751,90.36534Zm378.18,204.73385q-30.02666-31.21732-61.60766-61.01251Q736.702,485.22832,727.888,477.1377q-53.79024-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26675H809.712Zm-378.18-.50436V386.11086H615.1894q55.27878,42.9998,107.5639,90.81186,9.07848,8.29734,18.03343,16.727,31.30385,29.419,61.14458,60.30971ZM572.76419,350.0441C526.4777,316.33381,477.7769,284.3682,428.026,255.04016l-2.49708-1.47175v99.46885H576.87376Zm-143.92791-.3142V259.36456c47.32852,27.9968,93.67275,58.37489,137.86751,90.36534Zm378.18,204.73385q-30.02666-31.21732-61.60766-61.01251Q736.702,485.22832,727.888,477.1377q-53.79024-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26675H809.712Zm-378.18-.50436V386.11086H615.1894q55.27878,42.9998,107.5639,90.81186,9.07848,8.29734,18.03343,16.727,31.30385,29.419,61.14458,60.30971Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M659.26685,462.51354c0-14.562,11.80485-49.117,26.36687-49.117s26.36686,34.555,26.36686,49.117a26.36686,26.36686,0,1,1-52.73373,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M685.63371,526.66111a.2168.2168,0,0,1-.21681-.2168V435.54a.21681.21681,0,0,1,.43362,0v90.90428A.2168.2168,0,0,1,685.63371,526.66111Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M685.63371,453.08975a.21612.21612,0,0,1-.15332-.06352l-10.436-10.43591a.2168.2168,0,1,1,.30663-.30658l10.436,10.43591a.21681.21681,0,0,1-.15331.3701Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M685.63371,471.1564a.21681.21681,0,0,1-.15332-.3701l17.47691-17.477a.2168.2168,0,1,1,.30663.30658l-17.47691,17.477A.21613.21613,0,0,1,685.63371,471.1564Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M807.10675,388.09794c0-14.562,11.80485-49.117,26.36687-49.117s26.36686,34.55494,26.36686,49.117a26.36687,26.36687,0,0,1-52.73373,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M833.47361,452.24551a.2168.2168,0,0,1-.21681-.21681V361.12442a.21681.21681,0,0,1,.43362,0V452.0287A.2168.2168,0,0,1,833.47361,452.24551Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M833.47361,378.67414a.21615.21615,0,0,1-.15332-.06351l-10.436-10.43591a.2168.2168,0,0,1,.30663-.30658l10.436,10.4359a.21681.21681,0,0,1-.15332.3701Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M833.47361,396.74079a.21681.21681,0,0,1-.15332-.3701l17.47691-17.477a.21681.21681,0,0,1,.30664.30658l-17.47691,17.477A.2162.2162,0,0,1,833.47361,396.74079Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M483.39236,395.5395c0-14.562,11.80485-49.117,26.36687-49.117s26.36686,34.55494,26.36686,49.117a26.36686,26.36686,0,0,1-52.73373,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M509.75922,459.68707a.2168.2168,0,0,1-.21681-.21681V368.566a.21681.21681,0,1,1,.43362,0v90.90427A.2168.2168,0,0,1,509.75922,459.68707Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M509.75922,386.1157a.21615.21615,0,0,1-.15332-.06351l-10.436-10.43591a.2168.2168,0,0,1,.30663-.30658l10.436,10.43591a.2168.2168,0,0,1-.15332.37009Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M509.75922,404.18235a.2168.2168,0,0,1-.15332-.37009l17.47691-17.477a.21681.21681,0,0,1,.30664.30659l-17.47691,17.477A.2162.2162,0,0,1,509.75922,404.18235Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M726.65548,322.89406a75.71772,75.71772,0,1,1,75.71772-75.71772A75.80352,75.80352,0,0,1,726.65548,322.89406Zm0-150.41909a74.70137,74.70137,0,1,0,74.70137,74.70137A74.78593,74.78593,0,0,0,726.65548,172.475Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M726.65548,241.58644a.50819.50819,0,0,1-.50817-.50817V171.9668a.50817.50817,0,1,1,1.01634,0v69.11147A.50819.50819,0,0,1,726.65548,241.58644Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M801.865,247.68451H732.75355a.50817.50817,0,0,1,0-1.01634H801.865a.50817.50817,0,1,1,0,1.01634Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M720.55741,247.68451H651.47869a.50817.50817,0,0,1,0-1.01634h69.07872a.50817.50817,0,1,1,0,1.01634Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M726.65548,322.89406a.5082.5082,0,0,1-.50817-.50818V253.27441a.50817.50817,0,1,1,1.01634,0v69.11147A.5082.5082,0,0,1,726.65548,322.89406Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M731.136,243.55511a.50817.50817,0,0,1-.35929-.86746l48.65418-48.6543a.50812.50812,0,0,1,.71858.71859l-48.65417,48.6543A.50632.50632,0,0,1,731.136,243.55511Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M722.1751,243.55511a.50629.50629,0,0,1-.35929-.14887l-48.6543-48.6543a.50812.50812,0,0,1,.71858-.71859l48.6543,48.6543a.50817.50817,0,0,1-.35929.86746Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M779.79016,300.46821a.50628.50628,0,0,1-.35929-.14888L730.77669,251.665a.50812.50812,0,0,1,.71859-.71858l48.65417,48.6543a.50817.50817,0,0,1-.35929.86746Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M673.5208,300.46821a.50817.50817,0,0,1-.35929-.86746l48.6543-48.6543a.50811.50811,0,0,1,.71858.71858l-48.6543,48.6543A.50626.50626,0,0,1,673.5208,300.46821Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M726.65548,299.264a52.08769,52.08769,0,1,1,52.08769-52.08769A52.14669,52.14669,0,0,1,726.65548,299.264Zm0-103.159a51.07135,51.07135,0,1,0,51.07135,51.07135A51.12919,51.12919,0,0,0,726.65548,196.105Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 487.21154,
    cy: 88.44367,
    r: 6.09807,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "463.603 191.448 458.246 191.603 484.395 86.058 489.255 87.541 463.603 191.448",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "510.82 191.448 516.177 191.603 490.028 86.058 485.168 87.541 510.82 191.448",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 478.5726,
    y: 28.47931,
    width: 16.7697,
    height: 9.14711,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 479.58895,
    y: 30.512,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 487.71971,
    y: 30.512,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M726.40143,206.26845a9.66627,9.66627,0,0,1-9.65528-9.65528v-.25409a2.28936,2.28936,0,0,1,2.28678-2.28678h14.737a2.28935,2.28935,0,0,1,2.28677,2.28678v.25409A9.66626,9.66626,0,0,1,726.40143,206.26845Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M734.15814,189.49875H718.64473a1.2704,1.2704,0,0,1-1.13632-1.83865l3.049-6.09807a1.26333,1.26333,0,0,1,1.13632-.70221h9.41533a1.26334,1.26334,0,0,1,1.13632.70221l3.049,6.09807a1.27039,1.27039,0,0,1-1.13631,1.83865Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 523.79996,
    y: 48.80621,
    width: 16.7697,
    height: 9.14711,
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 524.81631,
    y: 50.8389,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 532.94707,
    y: 50.8389,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M771.62879,226.59535a9.66626,9.66626,0,0,1-9.65527-9.65528V216.686a2.28935,2.28935,0,0,1,2.28677-2.28677h14.737a2.28935,2.28935,0,0,1,2.28677,2.28677v.25409A9.66626,9.66626,0,0,1,771.62879,226.59535Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M766.92113,201.69489a.75817.75817,0,0,0-.68174.42133l-3.049,6.09807a.76217.76217,0,0,0,.68174,1.10319H779.3855a.76217.76217,0,0,0,.68174-1.10319l-3.049-6.09807a.75817.75817,0,0,0-.68174-.42133Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 541.58601,
    y: 94.54175,
    width: 16.7697,
    height: 9.14711,
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 542.60235,
    y: 96.57444,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 550.73311,
    y: 96.57444,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M789.41484,272.33088a9.66625,9.66625,0,0,1-9.65528-9.65528v-.25408a2.28935,2.28935,0,0,1,2.28677-2.28678h14.737a2.28936,2.28936,0,0,1,2.28678,2.28678v.25408A9.66626,9.66626,0,0,1,789.41484,272.33088Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M797.17154,255.56119H781.65813a1.27039,1.27039,0,0,1-1.13631-1.83865l3.049-6.09807a1.26335,1.26335,0,0,1,1.13632-.70222h9.41533a1.26334,1.26334,0,0,1,1.13632.70222l3.049,6.09807a1.2704,1.2704,0,0,1-1.13632,1.83865Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 522.78362,
    y: 137.22824,
    width: 16.7697,
    height: 9.14711,
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 523.79996,
    y: 139.26093,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 531.93073,
    y: 139.26093,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M770.61245,315.01738a9.66627,9.66627,0,0,1-9.65528-9.65528V305.108a2.28936,2.28936,0,0,1,2.28678-2.28678h14.737a2.28936,2.28936,0,0,1,2.28678,2.28678v.25408A9.66627,9.66627,0,0,1,770.61245,315.01738Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M778.36915,298.24769h-15.5134a1.2704,1.2704,0,0,1-1.13632-1.83866l3.049-6.09807a1.26336,1.26336,0,0,1,1.13632-.70221h9.41534a1.26333,1.26333,0,0,1,1.13631.70221l3.049,6.09807a1.2704,1.2704,0,0,1-1.13632,1.83866Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 673.2974,
    y: 207.53888,
    width: 16.7697,
    height: 9.14711,
    transform: "translate(1123.92051 265.4922) rotate(-180)",
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 682.4445,
    y: 209.57157,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1132.05127 267.52489) rotate(-180)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 674.31374,
    y: 209.57157,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1115.78975 267.52489) rotate(-180)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M681.68225,226.59535a9.66626,9.66626,0,0,1-9.65528-9.65528V216.686a2.28935,2.28935,0,0,1,2.28677-2.28677h14.737a2.28935,2.28935,0,0,1,2.28678,2.28677v.25409A9.66627,9.66627,0,0,1,681.68225,226.59535Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M689.439,209.82565H673.92554a1.27039,1.27039,0,0,1-1.13631-1.83865l3.049-6.09807a1.26334,1.26334,0,0,1,1.13632-.70221h9.41533a1.26333,1.26333,0,0,1,1.13632.70221l3.049,6.09807a1.2704,1.2704,0,0,1-1.13632,1.83865Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 655.51136,
    y: 253.27441,
    width: 16.7697,
    height: 9.14711,
    transform: "translate(1088.34843 356.96326) rotate(-180)",
    fill: "#ccc"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 664.65846,
    y: 255.3071,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1096.47919 358.99595) rotate(-180)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 656.5277,
    y: 255.3071,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1080.21767 358.99595) rotate(-180)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M663.8962,272.33088a9.66625,9.66625,0,0,1-9.65527-9.65528v-.25408a2.28935,2.28935,0,0,1,2.28677-2.28678h14.737a2.28935,2.28935,0,0,1,2.28677,2.28678v.25408A9.66625,9.66625,0,0,1,663.8962,272.33088Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M671.65291,255.56119H656.1395a1.2704,1.2704,0,0,1-1.13632-1.83865l3.049-6.09807a1.26334,1.26334,0,0,1,1.13632-.70222h9.41533a1.26334,1.26334,0,0,1,1.13632.70222l3.049,6.09807a1.2704,1.2704,0,0,1-1.13632,1.83865Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 674.31374,
    y: 295.96091,
    width: 16.7697,
    height: 9.14711,
    transform: "translate(1125.9532 442.33626) rotate(-180)",
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 683.46085,
    y: 297.9936,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1134.08396 444.36895) rotate(-180)",
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 675.33009,
    y: 297.9936,
    width: 6.60624,
    height: 7.11442,
    transform: "translate(1117.82244 444.36895) rotate(-180)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M682.69859,315.01738a9.66627,9.66627,0,0,1-9.65528-9.65528V305.108a2.28936,2.28936,0,0,1,2.28678-2.28678h14.737a2.28936,2.28936,0,0,1,2.28678,2.28678v.25408A9.66627,9.66627,0,0,1,682.69859,315.01738Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M690.45529,298.24769h-15.5134a1.2704,1.2704,0,0,1-1.13632-1.83866l3.049-6.09807a1.26333,1.26333,0,0,1,1.13631-.70221h9.41534a1.26336,1.26336,0,0,1,1.13632.70221l3.049,6.09807a1.2704,1.2704,0,0,1-1.13632,1.83866Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 478.5726,
    y: 156.5388,
    width: 16.7697,
    height: 9.14711,
    fill: "#ccc"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 479.58895,
    y: 158.57149,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 487.71971,
    y: 158.57149,
    width: 6.60624,
    height: 7.11442,
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M719.03293,322.64a1.78068,1.78068,0,0,0-1.7786,1.77861v.25408a9.14711,9.14711,0,1,0,18.29421,0v-.25408a1.78068,1.78068,0,0,0-1.7786-1.77861Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M721.69377,309.42748a.75816.75816,0,0,0-.68174.42133l-3.049,6.09807a.76217.76217,0,0,0,.68174,1.10319h15.51341a.76217.76217,0,0,0,.68174-1.10319l-3.049-6.09807a.75817.75817,0,0,0-.68174-.42133Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M502.67849,442.08992a.5734.5734,0,0,0,0-1.1468H497.2312v-2.2936h5.44729a.5734.5734,0,0,0,0-1.1468H456.23316a.5734.5734,0,0,0,0,1.1468h5.44729v2.2936h-5.44729a.5734.5734,0,0,0,0,1.1468h5.44729v2.29359h-5.44729a.5734.5734,0,0,0,0,1.1468h5.44729v2.2936h-4.8739a1.1468,1.1468,0,0,0,0,2.2936h4.63983a.8548.8548,0,0,0-.05263.28669v8.02759a.8601.8601,0,1,0,1.7202,0V450.4042a.85455.85455,0,0,0-.05264-.28669h32.789a.85455.85455,0,0,0-.05264.28669v8.02759a.8601.8601,0,1,0,1.7202,0V450.4042a.85455.85455,0,0,0-.05264-.28669h4.63983a1.1468,1.1468,0,0,0,0-2.2936H497.2312v-2.2936h5.44729a.5734.5734,0,0,0,0-1.1468H497.2312v-2.29359Zm-39.85124-3.4404H496.0844v2.2936H462.82725Zm33.25715,9.17439H462.82725v-2.2936H496.0844Zm0-3.4404H462.82725v-2.29359H496.0844Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M681.86034,510.71764a.5734.5734,0,0,0,0-1.1468h-5.44729v-2.29359h5.44729a.5734.5734,0,0,0,0-1.1468H635.415a.5734.5734,0,0,0,0,1.1468h5.4473v2.29359H635.415a.5734.5734,0,0,0,0,1.1468h5.4473v2.2936H635.415a.5734.5734,0,0,0,0,1.1468h5.4473v2.29359h-4.8739a1.1468,1.1468,0,0,0,0,2.2936h4.63983a.85485.85485,0,0,0-.05263.2867v8.02759a.8601.8601,0,1,0,1.72019,0v-8.02759a.85461.85461,0,0,0-.05263-.2867h32.789a.85461.85461,0,0,0-.05264.2867v8.02759a.8601.8601,0,0,0,1.7202,0v-8.02759a.85461.85461,0,0,0-.05264-.2867h4.63983a1.1468,1.1468,0,0,0,0-2.2936h-4.87389V514.158h5.44729a.5734.5734,0,0,0,0-1.1468h-5.44729v-2.2936Zm-39.85124-3.44039h33.25715v2.29359H642.0091Zm33.25715,9.17438H642.0091V514.158h33.25715Zm0-3.44039H642.0091v-2.2936h33.25715Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M826.39288,435.4752a.5734.5734,0,0,0,0-1.1468h-5.44729v-2.2936h5.44729a.5734.5734,0,0,0,0-1.1468H779.94755a.5734.5734,0,0,0,0,1.1468h5.44729v2.2936h-5.44729a.5734.5734,0,0,0,0,1.1468h5.44729v2.29359h-5.44729a.5734.5734,0,0,0,0,1.1468h5.44729v2.2936h-4.8739a1.1468,1.1468,0,0,0,0,2.29359h4.63983a.8549.8549,0,0,0-.05263.2867v8.02759a.8601.8601,0,0,0,1.7202,0v-8.02759a.85466.85466,0,0,0-.05264-.2867h32.789a.85466.85466,0,0,0-.05264.2867v8.02759a.8601.8601,0,0,0,1.7202,0v-8.02759a.85466.85466,0,0,0-.05264-.2867h4.63983a1.1468,1.1468,0,1,0,0-2.29359h-4.87389v-2.2936h5.44729a.5734.5734,0,0,0,0-1.1468h-5.44729V435.4752Zm-39.85124-3.4404h33.25715v2.2936H786.54164Zm33.25715,9.17439H786.54164v-2.2936h33.25715Zm0-3.4404H786.54164V435.4752h33.25715Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M608.71655,579.65019c0-14.70524-11.929-49.6-26.6442-49.6s-26.64419,34.89478-26.64419,49.6a26.6442,26.6442,0,0,0,53.28839,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M582.07235,638.65113a.30469.30469,0,0,1-.30468-.30468V576.1478a.30469.30469,0,1,1,.60937,0v62.19865A.3047.3047,0,0,1,582.07235,638.65113Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M582.0725,587.76868a.304.304,0,0,1-.23037-.105L566.51845,569.9919a.30474.30474,0,0,1,.46045-.3993l15.32368,17.67175a.30476.30476,0,0,1-.23008.50433Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M582.07235,597.96731a.30469.30469,0,0,1-.21542-.52011l8.70719-8.70733a.30465.30465,0,0,1,.43084.43084l-8.70718,8.70734A.30359.30359,0,0,1,582.07235,597.96731Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M354.58661,291.083c0-14.70523-11.929-49.6-26.6442-49.6s-26.64419,34.89479-26.64419,49.6a26.6442,26.6442,0,0,0,53.28839,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M327.94241,350.084a.3047.3047,0,0,1-.30468-.30469V287.58061a.30469.30469,0,0,1,.60937,0v62.19865A.30471.30471,0,0,1,327.94241,350.084Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M327.94256,299.2015a.304.304,0,0,1-.23037-.105l-15.32368-17.67175a.30474.30474,0,0,1,.46045-.39931l15.32368,17.67175a.30477.30477,0,0,1-.23008.50434Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M327.94241,309.40013a.30469.30469,0,0,1-.21542-.52011l8.70719-8.70734a.30465.30465,0,0,1,.43084.43085l-8.70718,8.70733A.3036.3036,0,0,1,327.94241,309.40013Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M299.08415,349.68021a11.12328,11.12328,0,0,1,22.24656,0",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M310.20743,349.68021a.30065.30065,0,0,1-.30063-.30063v-5.86227a.30063.30063,0,0,1,.60126,0v5.86227A.30065.30065,0,0,1,310.20743,349.68021Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M310.20729,347.66579a.29926.29926,0,0,1-.19568-.07252L306.4041,344.497a.30062.30062,0,1,1,.3916-.45623l3.60755,3.09627a.30063.30063,0,0,1-.196.52875Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M333.35587,349.68021a11.12328,11.12328,0,0,1,22.24656,0",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#f2f2f2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344.47915,349.68021a.30065.30065,0,0,1-.30063-.30063v-5.86227a.30063.30063,0,1,1,.60126,0v5.86227A.30065.30065,0,0,1,344.47915,349.68021Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M344.479,347.66579a.29926.29926,0,0,1-.19568-.07252l-3.60755-3.09627a.30064.30064,0,0,1,.39164-.45623L344.675,347.137a.30063.30063,0,0,1-.196.52875Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M914.35734,578.82335c0-14.70524-11.929-49.6-26.6442-49.6s-26.64419,34.89478-26.64419,49.6a26.6442,26.6442,0,0,0,53.28839,0Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M887.71314,637.82429a.30469.30469,0,0,1-.30468-.30468V575.321a.30469.30469,0,1,1,.60937,0v62.19865A.3047.3047,0,0,1,887.71314,637.82429Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M887.71329,586.94184a.304.304,0,0,1-.23037-.105l-15.32368-17.67175a.30474.30474,0,0,1,.46045-.3993l15.32368,17.67175a.30476.30476,0,0,1-.23008.50433Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M887.71314,597.14047a.30469.30469,0,0,1-.21542-.52011l8.70718-8.70733a.30465.30465,0,1,1,.43085.43084l-8.70719,8.70734A.30355.30355,0,0,1,887.71314,597.14047Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#ccc"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M496.115,583.48533h-5.16361a1.45391,1.45391,0,0,1-1.45227-1.45227v-6.77724a1.45391,1.45391,0,0,1,1.45227-1.45227H496.115a1.4539,1.4539,0,0,1,1.45226,1.45227v6.77724A1.4539,1.4539,0,0,1,496.115,583.48533Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M539.683,638.67144H513.21943a2.74623,2.74623,0,0,1-2.74316-2.74317v-51.3134a2.74623,2.74623,0,0,1,2.74316-2.74317H539.683a2.74624,2.74624,0,0,1,2.74317,2.74317v51.3134A2.74624,2.74624,0,0,1,539.683,638.67144Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M523.86938,638.67144H478.04232a2.74624,2.74624,0,0,1-2.74317-2.74317v-51.3134a2.74624,2.74624,0,0,1,2.74317-2.74317h45.82706a2.74624,2.74624,0,0,1,2.74317,2.74317v51.3134A2.74624,2.74624,0,0,1,523.86938,638.67144Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M491.27408,583.48533h-5.16361a1.45391,1.45391,0,0,1-1.45227-1.45227v-6.77724a1.45391,1.45391,0,0,1,1.45227-1.45227h5.16361a1.45391,1.45391,0,0,1,1.45227,1.45227v6.77724A1.45391,1.45391,0,0,1,491.27408,583.48533Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M498.05132,607.20567h-6.13179a.80776.80776,0,0,1-.80681-.80681v-9.35905a.80776.80776,0,0,1,.80681-.80681h6.13179a.80777.80777,0,0,1,.80682.80681v9.35905A.80777.80777,0,0,1,498.05132,607.20567Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M509.99218,607.20567h-6.13179a.80777.80777,0,0,1-.80682-.80681v-9.35905a.80777.80777,0,0,1,.80682-.80681h6.13179a.80776.80776,0,0,1,.80681.80681v9.35905A.80776.80776,0,0,1,509.99218,607.20567Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M498.05132,624.31014h-6.13179a.80776.80776,0,0,1-.80681-.80681v-9.35905a.80777.80777,0,0,1,.80681-.80682h6.13179a.80777.80777,0,0,1,.80682.80682v9.35905A.80777.80777,0,0,1,498.05132,624.31014Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M509.99218,624.31014h-6.13179a.80777.80777,0,0,1-.80682-.80681v-9.35905a.80777.80777,0,0,1,.80682-.80682h6.13179a.80777.80777,0,0,1,.80681.80682v9.35905A.80776.80776,0,0,1,509.99218,624.31014Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M312.43158,422.63774H306.3413a1.71479,1.71479,0,0,1-1.71289-1.7129V406.84107a1.71479,1.71479,0,0,1,1.71289-1.71289h6.09028a1.71479,1.71479,0,0,1,1.71289,1.71289v14.08377A1.71479,1.71479,0,0,1,312.43158,422.63774Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M336.41206,553.95939H305.19937a3.2391,3.2391,0,0,1-3.23546-3.23546V424.73127a3.2391,3.2391,0,0,1,3.23546-3.23546h31.21269a3.23908,3.23908,0,0,1,3.23546,3.23546V550.72393A3.23908,3.23908,0,0,1,336.41206,553.95939Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M317.76058,553.95939H286.54789a3.2391,3.2391,0,0,1-3.23546-3.23546V424.73127a3.2391,3.2391,0,0,1,3.23546-3.23546h31.21269a3.2391,3.2391,0,0,1,3.23546,3.23546V550.72393A3.2391,3.2391,0,0,1,317.76058,553.95939Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M306.72194,422.63774h-6.09028a1.7148,1.7148,0,0,1-1.71289-1.7129V406.84107a1.7148,1.7148,0,0,1,1.71289-1.71289h6.09028a1.7148,1.7148,0,0,1,1.7129,1.71289v14.08377A1.7148,1.7148,0,0,1,306.72194,422.63774Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72845,450.044h-7.23221a.95269.95269,0,0,1-.9516-.9516V438.05376a.95269.95269,0,0,1,.9516-.95161h7.23221a.9527.9527,0,0,1,.95161.95161v11.03863A.9527.9527,0,0,1,298.72845,450.044Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M312.81222,450.044H305.58a.9527.9527,0,0,1-.95161-.9516V438.05376a.9527.9527,0,0,1,.95161-.95161h7.2322a.9527.9527,0,0,1,.95161.95161v11.03863A.9527.9527,0,0,1,312.81222,450.044Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72845,470.21805h-7.23221a.9527.9527,0,0,1-.9516-.95161V458.22781a.95269.95269,0,0,1,.9516-.95161h7.23221a.9527.9527,0,0,1,.95161.95161v11.03863A.95271.95271,0,0,1,298.72845,470.21805Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M312.81222,470.21805H305.58a.95271.95271,0,0,1-.95161-.95161V458.22781a.9527.9527,0,0,1,.95161-.95161h7.2322a.9527.9527,0,0,1,.95161.95161v11.03863A.95271.95271,0,0,1,312.81222,470.21805Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72845,490.3921h-7.23221a.95269.95269,0,0,1-.9516-.95161V478.40186a.9527.9527,0,0,1,.9516-.95161h7.23221a.95271.95271,0,0,1,.95161.95161v11.03863A.9527.9527,0,0,1,298.72845,490.3921Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M312.81222,490.3921H305.58a.9527.9527,0,0,1-.95161-.95161V478.40186a.95271.95271,0,0,1,.95161-.95161h7.2322a.95271.95271,0,0,1,.95161.95161v11.03863A.9527.9527,0,0,1,312.81222,490.3921Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72845,510.56615h-7.23221a.95269.95269,0,0,1-.9516-.95161V498.57591a.95269.95269,0,0,1,.9516-.9516h7.23221a.9527.9527,0,0,1,.95161.9516v11.03863A.9527.9527,0,0,1,298.72845,510.56615Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M312.81222,510.56615H305.58a.9527.9527,0,0,1-.95161-.95161V498.57591a.9527.9527,0,0,1,.95161-.9516h7.2322a.9527.9527,0,0,1,.95161.9516v11.03863A.9527.9527,0,0,1,312.81222,510.56615Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72845,530.7402h-7.23221a.95269.95269,0,0,1-.9516-.9516V518.75a.95269.95269,0,0,1,.9516-.9516h7.23221a.9527.9527,0,0,1,.95161.9516V529.7886A.9527.9527,0,0,1,298.72845,530.7402Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M312.81222,530.7402H305.58a.9527.9527,0,0,1-.95161-.9516V518.75a.9527.9527,0,0,1,.95161-.9516h7.2322a.9527.9527,0,0,1,.95161.9516V529.7886A.9527.9527,0,0,1,312.81222,530.7402Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M796.83367,583.65849h-5.16361a1.4539,1.4539,0,0,1-1.45226-1.45227V575.429a1.4539,1.4539,0,0,1,1.45226-1.45227h5.16361a1.45391,1.45391,0,0,1,1.45227,1.45227v6.77724A1.45391,1.45391,0,0,1,796.83367,583.65849Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M840.40165,638.8446H813.93814a2.74624,2.74624,0,0,1-2.74317-2.74317V584.788a2.74624,2.74624,0,0,1,2.74317-2.74317h26.46351a2.74624,2.74624,0,0,1,2.74317,2.74317v51.3134A2.74624,2.74624,0,0,1,840.40165,638.8446Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#3f3d56"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M824.58809,638.8446H778.761a2.74624,2.74624,0,0,1-2.74317-2.74317V584.788a2.74624,2.74624,0,0,1,2.74317-2.74317h45.82706a2.74624,2.74624,0,0,1,2.74317,2.74317v51.3134A2.74624,2.74624,0,0,1,824.58809,638.8446Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M791.99279,583.65849h-5.16362a1.45391,1.45391,0,0,1-1.45226-1.45227V575.429a1.45391,1.45391,0,0,1,1.45226-1.45227h5.16362a1.45391,1.45391,0,0,1,1.45226,1.45227v6.77724A1.45391,1.45391,0,0,1,791.99279,583.65849Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#6c63ff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M798.77,607.37883h-6.13179a.80777.80777,0,0,1-.80682-.80681v-9.359a.80777.80777,0,0,1,.80682-.80681H798.77a.80776.80776,0,0,1,.80681.80681v9.359A.80776.80776,0,0,1,798.77,607.37883Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M810.71088,607.37883h-6.13179a.80776.80776,0,0,1-.80681-.80681v-9.359a.80776.80776,0,0,1,.80681-.80681h6.13179a.80777.80777,0,0,1,.80682.80681v9.359A.80777.80777,0,0,1,810.71088,607.37883Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M798.77,624.4833h-6.13179a.80777.80777,0,0,1-.80682-.80681v-9.359a.80777.80777,0,0,1,.80682-.80682H798.77a.80777.80777,0,0,1,.80681.80682v9.359A.80776.80776,0,0,1,798.77,624.4833Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M810.71088,624.4833h-6.13179a.80776.80776,0,0,1-.80681-.80681v-9.359a.80777.80777,0,0,1,.80681-.80682h6.13179a.80777.80777,0,0,1,.80682.80682v9.359A.80777.80777,0,0,1,810.71088,624.4833Z",
    transform: "translate(-239.44398 -158.73267)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTouristMapRe293E);
export default __webpack_public_path__ + "static/media/undraw_tourist_map_re_293e.deef219b2b0df4686d15f8e9dd040f4a.svg";
export { ForwardRef as ReactComponent };